import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

import { formatNumber } from '../../../assets/shared/formatNumber';
import Table from '../../UI/Table/Table';
import classes from './TablaInflacion.css';
import TablaInflacionMesAMes from './TablaInflacionMesAMes.js';

const TablaInflacionPorAnio = (props) => {
  const { onLoadInflacionPorAnio, inflacionLocal, loading, estaCargado } = props;

  useEffect(() => {
    if (inflacionLocal.length === 0) {
      if (!estaCargado && !loading) onLoadInflacionPorAnio();
    }
  }, [inflacionLocal, estaCargado, onLoadInflacionPorAnio]);

  const columns = [
    {
      title: 'Año',
      field: 'anio',
      align: 'right',
      cellStyle: {
        fontSize: '12px',
        paddingBottom: '5px',
        paddingTop: '5px'
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: 'rgb(220 220 220)'
      },
      defaultSort: 'desc'
    },
    {
      title: `Porcentaje`,
      field: 'inflacionAcumulada',
      align: 'right',
      type: 'numeric',
      cellStyle: (cellData) => {
        return {
          fontSize: '12px',
          paddingBottom: '5px',
          paddingTop: '5px'
        };
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: 'rgb(220 220 220)'
      },
      render: (rowData) => `${formatNumber(rowData.inflacionAcumulada)}%`
    }
  ];

  const data = () => {
    return inflacionLocal.map((inflacion) => {
      return {
        anio: inflacion.anio,
        inflacionAcumulada: inflacion.inflacionAcumulada,
        Inflacion: inflacion.inflacion
      };
    });
  };

  const autoScroll = (rowData) => {
    if (tableRef.current) {
      const indexRow = tableRef.current.state.data.indexOf(tableRef.current.state.originalData[rowData.tableData.id]);

      tableRef.current.tableContainerDiv.current.scrollTop = 49 * indexRow;
    }
  };

  const tableRef = useRef();
  return (
    <div className={classes.tablaInflacion}>
      <Table
        tableRef={tableRef}
        style={{ width: '95%', marginTop: 0, marginBottom: '15px' }}
        title=""
        noBoxShadow
        columns={columns}
        data={data()}
        detailPanel={(rowData) => {
          setTimeout(() => {
            autoScroll(rowData);
          }, 100);
          return <TablaInflacionMesAMes inflacion={rowData.Inflacion} />;
        }}
        customOptions={{
          thirdSortClick: false,
          sorting: true,
          grouping: false,
          draggable: false,
          search: false,
          paging: false,
          toolbar: false,
          showTitle: false,
          maxBodyHeight: 450
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    inflacionLocal: state.configuraciones.loadInflacionPorAnio.inflaciones,
    loading: state.configuraciones.loadInflacionPorAnio.loading,
    estaCargado: state.configuraciones.loadInflacionPorAnio.estaCargado
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadInflacionPorAnio: () => dispatch(actions.LoadInflacionPorAnio())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablaInflacionPorAnio);
